import { useQuery } from '@tanstack/react-query';
import type { Brief, CursorPage } from '@seo/types';
import { apiGet } from '@/lib/api';

export function useBriefs(projectId?: string, limit = 50) {
  const params = new URLSearchParams();
  if (projectId) params.set('project_id', projectId);
  params.set('limit', String(limit));
  return useQuery({
    queryKey: ['briefs', { projectId, limit }],
    queryFn: () => apiGet<CursorPage<Brief>>(`/v1/briefs?${params.toString()}`),
  });
}
